import React from 'react';
import { mergeClassLists } from 'tailwind-classlist';
import { classes } from './utils';

export default function Content({ className = '', ...props }) {
  return (
    <p className={mergeClassLists(classes.content, className)} {...props} />
  );
}
